import {useCreateRecordAuditDefinitionMutation} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {ApiError, useNavigate} from 'shared/web';

import {RecordAuditDefinitionForm} from '../../components/RecordAuditDefinitionForm';
import {toCreateRecordAuditDefinitionBody} from '../../utils/toRecordAuditDefinitionRequestBody';

export function Create() {
  const navigate = useNavigate();

  const [createRecordAuditDefinition, createRecordAuditDefinitionQuery] =
    useCreateRecordAuditDefinitionMutation();

  return (
    <SettingsTemplate
      header={{
        title: i18n.t('page.settings.generalChecklist.create'),
        breadcrumbs: [
          {
            label: i18n.t('page.generalSettings.labels.title'),
            isCurrentPage: true,
          },
          {
            label: i18n.t('page.settings.generalChecklist.title'),
            href: settingsRoutes.recordAuditDefinition,
          },
        ],
      }}
      isCreating
      data-testid={testIds.settings.recordAuditDefinitionCreate('newTemplate')}
    >
      <RecordAuditDefinitionForm
        onSubmit={async (formData, _setErrors, _reset, blockerContext) => {
          await createRecordAuditDefinition({
            body: toCreateRecordAuditDefinitionBody(formData),
          })
            .unwrap()
            .then(() => {
              if (blockerContext?.wasSubmittedFromBlocker) {
                return;
              }
              navigate(settingsRoutes.recordAuditDefinition);
            })
            .catch((e: ApiError) =>
              handleApiError(e, {signalApiError: blockerContext?.reportApiFailure})
            );
        }}
        isLoading={createRecordAuditDefinitionQuery.isLoading}
      />
    </SettingsTemplate>
  );
}
